import { Intent } from '@blueprintjs/core';

export default function (error, options) {
  const title = "We're sorry, something went wrong on our side";
  const description = "The issue has been reported and we'll do our best to fix the problem as soon as possible.";
  const message = "We're sorry, something went wrong on our side.";

  return {
    title,
    description,
    message,
    toast: true,
    intent: Intent.DANGER,
    icon: 'error',
  };
}
